<template>
  <p>
    Tente novamente em alguns instantes, caso o erro persista, entre em contato com nosso
    time de atendimento.
  </p>
</template>
